import { ReportError } from "shared/errors";

export class ReportService {
  httpClient;
  baseUrl;

  constructor(baseUrl, apiClient) {
    this.httpClient = apiClient;
    this.baseUrl = baseUrl;
  }

downloadreport = async (data) => {
  const url = `${this.baseUrl}/reports`;
  const response = await this.httpClient.post(url, data, {
    responseType: 'blob'
  });
    // isSuccessful is only returned as false when an error has occurred
  if (response.isSuccessful === false) {
    throw new ReportError();
  }
  const contentType = response.headers["content-type"];
  if (contentType && contentType.includes("application/json")) {
    const text = await response.data.text();
    const json = JSON.parse(text);

    if (json.download_url) {
      return {
        type: "redirect",
        url: `${this.baseUrl}${json.download_url}`,
      };
    }
  }
  return {
    type: "blob",
    data: response.data,
    headers: response.headers,
  };
};
}
